import { Swiper, Pagination, Navigation, Thumbs } from 'swiper';
Swiper.use( [Pagination, Navigation, Thumbs ] );

class ThumbnailCarousel {
	constructor( carousel ) {

		let mainCarousel = carousel.querySelector(".block-thumbnail-carousel__main");
		let navCarousel = carousel.querySelector(".block-thumbnail-carousel__nav");

		let arrowNext = carousel.querySelector(".swiper-button-next");
		let arrowPrev = carousel.querySelector(".swiper-button-prev");

		var swiper = new Swiper(navCarousel, {
			spaceBetween: 10,
			slidesPerView: 5,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

		var swiper2 = new Swiper(mainCarousel, {
			loop: true,
			spaceBetween: 10,
			navigation: {
			  nextEl: arrowNext,
			  prevEl: arrowPrev,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			thumbs: {
			  swiper: swiper,
			},
		});
	}
}

export default ThumbnailCarousel;
